import React from 'react';

const Backdrop = props => {
    const classList = ['backdrop'];
    if (props.enable) {
        classList.push('backdrop--enable');
    }
    return (
        <div className={classList.join(' ')} onClick={props.clicked}></div>
    );
}

export default Backdrop;